import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'
import { USER_ROLES } from 'utils/constants/userRoles'

import ProcessesForm from './ProcessesForm'
import NegativeMediaForm from './NegativeMediaForm'
import FinancialPendingsForm from './FinancialPendingsForm'
import PepForm from './PepForm'
import PartnershipsForm from './PartnershipsForm'
import RestrictiveListForm from './RestrictiveListForm'
import FinancialPendingsAnswer from './FinancialPendingsAnswer'
import NegativeMediaAnswer from './NegativeMediaAnswer'
import PartnershipsAnswer from './PartnershipsAnswer'
import PepAnswer from './PepAnswer'
import ProcessAnswer from './ProcessAnswer'
import RestrictiveListAnswer from './RestrictiveListAnswer'

function RenderContent(props) {
  const { questionData } = props

  const token = useSelector((state) => state.auth.access_token)
  const currentRole = jwtDecode(token)?.extras?.role

  const components = {
    answered: {
      financial_pendency: FinancialPendingsAnswer,
      pep: PepAnswer,
      partnerships: PartnershipsAnswer,
      processes: ProcessAnswer,
      restriction_list: RestrictiveListAnswer,
      negative_media: NegativeMediaAnswer,
    },

    blank: {
      financial_pendency: FinancialPendingsForm,
      pep: PepForm,
      partnerships: PartnershipsForm,
      processes: ProcessesForm,
      restriction_list: RestrictiveListForm,
      negative_media: NegativeMediaForm,
    },
  }

  const types = [
    'financial_pendency',
    'pep',
    'partnerships',
    'processes',
    'restriction_list',
    'negative_media',
  ]

  const key =
    currentRole !== USER_ROLES.PROSPECT || questionData.answered
      ? 'answered'
      : 'blank'
  const Render = types.includes(questionData.subject)
    ? components[key][questionData.subject]
    : () => {
        console.error("Tipo de pergunta automática inválida.")
        return <p>Falha ao renderizar a pergunta requisitada.</p>
      }

  return (
    <div>
      <Render questionData={questionData} />
    </div>
  )
}

RenderContent.propTypes = {
  questionData: PropTypes.object.isRequired,
}

export default RenderContent
